import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { VesselService } from '../services/vessel';
import { UploadService } from '../services/upload-service';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const veselResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
  ) => {
  const vesselService = inject(VesselService);
  const uploadService = inject(UploadService);
  const imo = route.paramMap.get('imo');
  if (imo) {
    const vessel$ = vesselService.getVesselByIMO(imo);
    const image$ = uploadService.downloadFile(imo).pipe(
      map((buffer: ArrayBuffer) => {        
        return new Blob([buffer], { type: '' });
      }),
      catchError(() => of(null))
    );
    return forkJoin({ vessel: vessel$, image: image$ });
  }
  return null;
};
